import React from 'react';

import styles from './styles.module.scss';

const Footer = () => {
    return <div className={styles.footer}></div>;
};

export default Footer;
